module.exports = __webpack_public_path__ + "static/media/Tracking_fr.9e232fac.png";